import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Fab,
	Tooltip,
} from '@material-ui/core';
import { AiOutlineWarning } from 'react-icons/ai';
import React from 'react';

export default function SampleTag() {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Tooltip title='This is a sample website' placement='left' arrow>
				<Fab
					color='secondary'
					aria-label='add'
					style={{
						position: 'fixed',
						top: 10,
						right: 10,
						zIndex: 1000,
					}}
					onClick={handleClickOpen}
				>
					<AiOutlineWarning fontSize={28}/>
				</Fab>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
			>
				<DialogTitle id='alert-dialog-title'>
					<span style={{ color: 'black' }}>
						This is a sample website!
					</span>
				</DialogTitle>
				<DialogContent>
					<DialogContentText id='alert-dialog-description'>
						Riddler is an online cryptic hunt organized by{' '}
						<a href='https://csivit.com' target='blank'>
							CSI-VIT
						</a>{' '}
						and was held from 20th to 22nd August 2021. This is a
						showcase deployment to demonstrate the design and
						functionalities of the website.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color='primary' autoFocus>
						Okay
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
